import { Component } from '@angular/core';
import { SUPPORT_EMAIL } from '../../../../app.constants';

@Component({
  selector: 'app-returns',
  templateUrl: './returns.page.html',
  styleUrl: '../legal.page.scss'
})
export class ReturnsPage {
  readonly supportEmail = SUPPORT_EMAIL;
}
